// Main shop-by-animal categories shown in the header. Each `tag` and every
// subcategory name must match a real Shopify product tag exactly (verified
// against the live catalog) — this drives /:category and /:category/:subcategory
// pages via tag filtering, no Shopify Collections involved.
export const CATEGORIES = [
  {
    slug: 'dogs',
    label: 'Dogs',
    tag: 'Dogs',
    subtitle: 'Everyday essentials picked for dogs.',
    subcategories: ['Toys', 'Collars', 'Leashes', 'Harnesses', 'Grooming', 'Hygiene', 'Training'],
  },
  {
    slug: 'cats',
    label: 'Cats',
    tag: 'Cats',
    subtitle: 'Everyday essentials picked for cats.',
    subcategories: ['Collars', 'Leashes', 'Grooming', 'Toys', 'Hygiene'],
  },
  {
    slug: 'small-animals',
    label: 'Small Animals',
    tag: 'Small Animals',
    subtitle: 'Care essentials for small animals.',
    subcategories: ['Grooming', 'Hygiene'],
  },
  {
    slug: 'health-and-wellness',
    label: 'Health & Wellness',
    tag: 'Health and Wellness',
    subtitle: 'Health, recovery, and wellness essentials for pets.',
    subcategories: [],
  },
];

export function getCategoryBySlug(slug) {
  return CATEGORIES.find((c) => c.slug === slug) || null;
}

export function getSubcategorySlug(tag) {
  return tag.toLowerCase();
}

export function getSubcategoryTag(category, subcategorySlug) {
  return category.subcategories.find((t) => getSubcategorySlug(t) === subcategorySlug) || null;
}
